import { useState } from 'react';
import Login from './login';

export default function Home({ appEnv }) {
  const [showLogin, setShowLogin] = useState(true);

  return <>{showLogin ? <Login setShowLogin={setShowLogin} appEnv={appEnv} /> : null}</>;
}
